/**
 * Utility function to detect prefers-reduced-motion accessibility setting
 *
 * This function safely handles prefers-reduced-motion detection in both browser and SSR environments.
 *
 * @returns boolean - true when reduced motion is preferred, false otherwise
 */
export const prefersReducedMotion = (): boolean => {
  if (typeof globalThis !== "undefined" && globalThis.matchMedia) {
    const mediaQuery = globalThis.matchMedia("(prefers-reduced-motion: reduce)");
    return mediaQuery.matches;
  }

  return false;
};

export default prefersReducedMotion;
